import axios from 'axios';
import {getDomain} from "../utils/aemEndpointUtil";

const ECOM_PROXY_PATH = "/bin/os/";

export function getEndpointBase(endpoint) {
    return `${getDomain()}${ECOM_PROXY_PATH}${endpoint}`;
}

export function getAxios() {
    axios.defaults.headers['Content-Type'] = 'application/json';

    return axios;
}
